import { FiltersFormPlace } from 'civil-status/view-models/place';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValues: FiltersFormPlace = {
  orders: {},
  page: 0,
  description: '',
  id: '',
  rowsPerPage: 10,
};

const DeathplaceInitializer = (): React.ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

DeathplaceInitializer.displayName = 'Death initializer component';

export default DeathplaceInitializer;
